/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemDataSetResponseSchema = z.object({
  level: z.int().nullish(),
  parentId: z.int().nullish(),
});
